<template>
  <div class="container border-div p-b-md">
    <div class="columns">
      <div class="column content section">
        <div class="columns is-centered">
          <!-- <div class="column is-two-thirds"> -->
          <div class="column is-four-fifths">
            <nav class="breadcrumb no-left-margin columns" aria-label="breadcrumbs">
              <div class="column is-10">
                <ul class="no-left-margin">
                  <li class="no-top-margin">
                    <router-link
                    :to="`/invoices/`"
                    class=""
                    >
                      Submitted invoices
                    </router-link>
                  </li>
                  <li class="no-top-margin is-active"><a href="#" aria-current="page">{{ this.invoice.confirmationNumber }}</a></li>
                </ul>
              </div>
            </nav>

            <h3 class="has-text-centered">
              Submitted Invoice Details
            </h3>
            <div class="columns header-box">
              <div class="column is-one-fifth has-text-centered">
                <div class="bold">Confirmation number</div>
                <div>{{this.invoice.confirmationNumber}}</div>
              </div>
              <div class="column is-one-fifth has-text-centered">
                <div class="bold">Submitted on</div>
                <div>{{new Date(this.invoice.submittedOn).toLocaleDateString()}}</div>
              </div>
              <div class="column is-one-fifth has-text-centered">
                <div class="bold">Submitted by</div>
                <div class="wrappable">{{this.invoice.submittedBy}}</div>
              </div>
              <div class="column is-one-fifth has-text-centered">
                <div class="bold">Department</div>
                <div>{{this.invoice.department}}</div>
              </div>
              <div class="column is-one-fifth has-text-centered">
                <div class="bold">Unit</div>
                <div>{{this.invoice.unit}}</div>
              </div>

            </div>

            <div class="columns gray-box">
              <div class="column is-3 bold">
                <div>Vendor name</div>
                <div>Vendor EIN</div>
                <div>Invoice type</div>
                <div>Purchase order number</div>
                <div>Invoice number</div>
                <div>Invoice amount</div>
                <div>Is part of contract?</div>
                <div>Contract number</div>
                <div>Uploaded invoice</div>
                <div>Supporting documents</div>
              </div>
              <div class="column is-9">
                <div>{{this.invoice.vendorName}}</div>
                <div>{{this.invoice.ein}}</div>
                <div>{{ getInvoiceType(this.invoice.invoiceType) }}</div>
                <div>{{this.invoice.purchaseOrderNumber || 'N/A'}}</div>
                <div>{{this.invoice.invoiceNumber || 'N/A'}}</div>
                <div>{{ getInvoiceAmount(this.invoice.invoiceAmount) }}</div>
                <div>{{this.invoice.hasContractNum ? 'Yes' : 'No'}}</div>
                <div>{{this.invoice.contractNum || 'N/A'}}</div>

                <div v-if="this.invoice.invoiceFileName">
                  <a @click="$store.dispatch('invoices/downloadInvoice', { confirmationNumber: invoice.confirmationNumber, fileName: invoice.invoiceFileName})">
                    {{ this.invoice.invoiceFileName }}
                  </a>
                </div>
                <div v-else>
                  No invoice uploaded
                </div>

                <div v-if="this.invoice.supportingDocuments.length">
                  <div
                    v-for="(doc) of this.invoice.supportingDocuments"
                    :key="doc"
                  >
                    <a @click="$store.dispatch('invoices/downloadInvoice', { confirmationNumber: invoice.confirmationNumber, fileName: doc })">
                      {{ doc }}
                    </a>
                  </div>
                </div>
                <div v-else>
                  No supporting documents uploaded
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Invoice',
  data() {
    return {

    };
  },
  computed: {
    invoice() {
      return this.$store.state.invoices.invoice || [];
    },
  },
  async fetch({ store, params }) {
    let invoice = params.id;
    if (params.id === 'own') {
      invoice = null;
    }

    await store.dispatch('invoices/getInvoice', invoice);
    return Promise.resolve();
  },
  methods: {
    getInvoiceAmount(amount) {
      console.log('getInvoiceAmount amount:', amount);
      if (amount === null || amount === undefined || isNaN(amount) || amount === '') {
        return '$0.00';
      }
      return '$'+parseFloat(amount).toFixed(2);
    },
    getInvoiceType(type) {
      console.log('getInvoiceType type:', type);
      const invoiceTypes = {
        'purchase-order-invoice': 'Purchase order',
        'professional-services-invoice': 'Professional services',
        'public-works-invoice': 'Public Works',
        'other': 'Other',
      };
      return invoiceTypes[type] || 'Unknown';
    },
  },
};
</script>

<style lang="scss" scoped>

.wrappable {
  word-break: break-all;
}

.header-box {
  background-color: $ben-franklin-blue-light;
  padding: 20px;
}

.gray-box {
  background-color: $ghost-grey;
  padding: 20px;
  margin-top: 20px;
}

.bold {
  font-weight: bold;
}

.breadcrumb {
  margin-top: 1rem;
}

.no-left-margin {
  margin-left: 0px !important;
}

.no-top-margin {
  margin-top: 0px !important;
}

.section {
  padding: 1rem 1.5rem !important;
}

</style>
